document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-menu]');
  const mobileNav = document.querySelector('.mobile-nav');

  if (menu && mobileNav) {
    menu.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('open');
      menu.setAttribute('aria-expanded', String(open));
      menu.textContent = open ? '×' : '☰';
    });
  }

  const requestForms = Array.from(document.querySelectorAll('.request-form')).filter((form) =>
    form.querySelector('[name="contact[Request type]"]')
  );

  if (!requestForms.length) return;

  const regionsByCountry = {
    GH: ['Ahafo', 'Ashanti', 'Bono', 'Bono East', 'Central', 'Eastern', 'Greater Accra', 'North East', 'Northern', 'Oti', 'Savannah', 'Upper East', 'Upper West', 'Volta', 'Western', 'Western North'],
    NG: ['Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue', 'Borno', 'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu', 'Federal Capital Territory', 'Gombe', 'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara', 'Lagos', 'Nasarawa', 'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara'],
    KE: ['Baringo', 'Bomet', 'Bungoma', 'Busia', 'Elgeyo-Marakwet', 'Embu', 'Garissa', 'Homa Bay', 'Isiolo', 'Kajiado', 'Kakamega', 'Kericho', 'Kiambu', 'Kilifi', 'Kirinyaga', 'Kisii', 'Kisumu', 'Kitui', 'Kwale', 'Laikipia', 'Lamu', 'Machakos', 'Makueni', 'Mandera', 'Marsabit', 'Meru', 'Migori', 'Mombasa', 'Murang’a', 'Nairobi', 'Nakuru', 'Nandi', 'Narok', 'Nyamira', 'Nyandarua', 'Nyeri', 'Samburu', 'Siaya', 'Taita-Taveta', 'Tana River', 'Tharaka-Nithi', 'Trans Nzoia', 'Turkana', 'Uasin Gishu', 'Vihiga', 'Wajir', 'West Pokot'],
    ZA: ['Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo', 'Mpumalanga', 'North West', 'Northern Cape', 'Western Cape'],
    GB: ['England', 'Northern Ireland', 'Scotland', 'Wales'],
    US: ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
    CA: ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon'],
    AU: ['Australian Capital Territory', 'New South Wales', 'Northern Territory', 'Queensland', 'South Australia', 'Tasmania', 'Victoria', 'Western Australia']
  };

  const countryCodes = 'AD,AE,AF,AG,AI,AL,AM,AO,AQ,AR,AS,AT,AU,AW,AX,AZ,BA,BB,BD,BE,BF,BG,BH,BI,BJ,BL,BM,BN,BO,BQ,BR,BS,BT,BV,BW,BY,BZ,CA,CC,CD,CF,CG,CH,CI,CK,CL,CM,CN,CO,CR,CU,CV,CW,CX,CY,CZ,DE,DJ,DK,DM,DO,DZ,EC,EE,EG,EH,ER,ES,ET,FI,FJ,FK,FM,FO,FR,GA,GB,GD,GE,GF,GG,GH,GI,GL,GM,GN,GP,GQ,GR,GS,GT,GU,GW,GY,HK,HM,HN,HR,HT,HU,ID,IE,IL,IM,IN,IO,IQ,IR,IS,IT,JE,JM,JO,JP,KE,KG,KH,KI,KM,KN,KP,KR,KW,KY,KZ,LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MH,MK,ML,MM,MN,MO,MP,MQ,MR,MS,MT,MU,MV,MW,MX,MY,MZ,NA,NC,NE,NF,NG,NI,NL,NO,NP,NR,NU,NZ,OM,PA,PE,PF,PG,PH,PK,PL,PM,PN,PR,PS,PT,PW,PY,QA,RE,RO,RS,RU,RW,SA,SB,SC,SD,SE,SG,SH,SI,SJ,SK,SL,SM,SN,SO,SR,SS,ST,SV,SX,SY,SZ,TC,TD,TF,TG,TH,TJ,TK,TL,TM,TN,TO,TR,TT,TV,TW,TZ,UA,UG,UM,US,UY,UZ,VA,VC,VE,VG,VI,VN,VU,WF,WS,YE,YT,ZA,ZM,ZW'.split(',');

  const displayNames = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' });
  const countries = countryCodes
    .map((code) => ({ code, name: displayNames.of(code) }))
    .filter((country) => country.name && country.name !== country.code)
    .sort((a, b) => a.name.localeCompare(b.name));

  const createOption = (value, label, disabled = false) => {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = label;
    option.disabled = disabled;
    return option;
  };

  const createField = ({ id, label, name, type = 'text', full = false, placeholder, attributes = {} }) => {
    const field = document.createElement('div');
    field.className = full ? 'field full' : 'field';

    const fieldLabel = document.createElement('label');
    fieldLabel.htmlFor = id;
    fieldLabel.textContent = label;

    const input = document.createElement(type === 'textarea' ? 'textarea' : type === 'select' ? 'select' : 'input');
    input.id = id;
    input.name = name;
    input.required = true;
    input.placeholder = placeholder;
    Object.entries(attributes).forEach(([key, value]) => input.setAttribute(key, value));

    field.append(fieldLabel, input);
    return field;
  };

  const addFieldExample = (form, fieldName, message) => {
    const field = form.querySelector(`[name="${fieldName}"]`);
    const fieldWrap = field?.closest('.field');
    if (!fieldWrap || fieldWrap.querySelector('.field-example')) return;

    const example = document.createElement('small');
    example.className = 'field-example';
    example.textContent = message;
    fieldWrap.append(example);
  };

  const setValidationState = (field) => {
    if (!field || field.type === 'hidden' || field.disabled || field.closest('[hidden]')) {
      if (field) {
        field.setCustomValidity('');
        field.classList.remove('is-invalid');
      }
      return;
    }

    const value = field.value.trim();
    let message = '';

    if (field.required && !value) {
      message = 'This field is required.';
    } else if (field.dataset.phoneInput && !/^\+?\d{7,15}$/.test(value.replace(/[\s().-]/g, ''))) {
      message = 'Enter a valid WhatsApp number, including the country code.';
    } else if (field.dataset.urlList && value) {
      const links = value.split(/[\n,]+/).map((link) => link.trim()).filter(Boolean);
      const validLinks = links.length > 0 && links.every((link) => {
        try {
          const url = new URL(link);
          return url.protocol === 'https:' || url.protocol === 'http:';
        } catch (error) {
          return false;
        }
      });
      if (!validLinks) message = 'Enter a valid web link. Add multiple links on separate lines.';
    }

    field.setCustomValidity(message);
    field.classList.toggle('is-invalid', Boolean(message) || !field.validity.valid);
  };

  const setRegions = (countrySelect, regionSelect) => {
    const countryCode = countrySelect.selectedOptions[0]?.dataset.countryCode;
    const regions = regionsByCountry[countryCode] || ['Other / region not listed'];

    const regionPlaceholder = createOption('', countryCode ? 'Select your delivery region' : 'Select delivery country first');
    regionPlaceholder.selected = true;
    regionSelect.replaceChildren(regionPlaceholder);
    if (!countryCode) {
      regionSelect.disabled = true;
      setValidationState(regionSelect);
      return;
    }

    regions.forEach((region) => regionSelect.append(createOption(region, region)));
    regionSelect.disabled = false;
    setValidationState(regionSelect);
  };

  const prepareRequestForm = (form) => {
    const requestTypeField = form.querySelector('[name="contact[Request type]"]');
    const prefix = 'request';
    const countryInput = form.querySelector('input[name="contact[Delivery country]"]');
    if (!requestTypeField || !countryInput) return;
    const countryField = countryInput.closest('.field');
    const countrySelect = document.createElement('select');
    countrySelect.id = countryInput.id;
    countrySelect.name = countryInput.name;
    countrySelect.required = true;
    countrySelect.dataset.countrySelect = '';
    const countryPlaceholder = createOption('', 'Select your delivery country');
    countryPlaceholder.selected = true;
    countrySelect.append(countryPlaceholder);
    countries.forEach((country) => {
      const option = createOption(country.name, country.name);
      option.dataset.countryCode = country.code;
      countrySelect.append(option);
    });
    countryInput.replaceWith(countrySelect);

    let regionInput = form.querySelector('input[name="contact[Delivery Region]"]');
    let regionSelect;
    if (regionInput) {
      regionSelect = document.createElement('select');
      regionSelect.id = regionInput.id;
      regionSelect.name = regionInput.name;
      regionSelect.required = true;
      regionSelect.dataset.regionSelect = '';
      regionInput.replaceWith(regionSelect);
    } else {
      const regionField = createField({
        id: `${prefix}-region`,
        label: 'Delivery region',
        name: 'contact[Delivery Region]',
        type: 'select',
        placeholder: ''
      });
      regionSelect = regionField.querySelector('select');
      regionSelect.dataset.regionSelect = '';
      const budgetField = form.querySelector('input[name="contact[Budget]"]')?.closest('.field');
      form.insertBefore(regionField, budgetField);
    }

    const requiredFields = [
      { name: 'contact[City]', id: `${prefix}-city`, label: 'City or town', placeholder: 'Your city or town', attributes: { minlength: '2', maxlength: '80', autocomplete: 'address-level2' } },
      { name: 'contact[WhatsApp]', id: `${prefix}-whatsapp`, label: 'WhatsApp number', placeholder: 'Include country code, e.g. +233...', attributes: { type: 'tel', inputmode: 'tel', autocomplete: 'tel', 'data-phone-input': '' } },
      { name: 'contact[Street Address]', id: `${prefix}-street-address`, label: 'Street address', placeholder: 'House number, street and area', full: true, attributes: { minlength: '5', maxlength: '180', autocomplete: 'street-address' } },
      { name: 'contact[GPS Address]', id: `${prefix}-gps-address`, label: 'GPS or digital address', placeholder: 'e.g. digital address or map location', full: true, attributes: { minlength: '4', maxlength: '120' } }
    ];

    const budgetField = form.querySelector('input[name="contact[Budget]"]')?.closest('.field');
    requiredFields.forEach((details) => {
      let field = form.querySelector(`[name="${details.name}"]`);
      if (!field) {
        const newField = createField(details);
        form.insertBefore(newField, budgetField);
        field = newField.querySelector('input, textarea, select');
      }
      field.required = true;
      Object.entries(details.attributes || {}).forEach(([key, value]) => field.setAttribute(key, value));
      const label = form.querySelector(`label[for="${field.id}"]`);
      if (label) label.textContent = details.label;
    });

    const productLinks = form.querySelector('textarea[name="contact[Product links]"]');
    const itemDescription = form.querySelector('textarea[name="contact[Item description]"]');
    const budget = form.querySelector('input[name="contact[Budget]"]');
    const productLinksWrap = productLinks?.closest('.field');
    const itemDescriptionWrap = itemDescription?.closest('.field');
    const budgetWrap = budget?.closest('.field');

    const setVisible = (field, visible, required) => {
      const wrap = field?.closest('.field');
      if (!field || !wrap) return;
      wrap.hidden = !visible;
      field.disabled = !visible;
      field.required = required;
      if (!visible) setValidationState(field);
    };

    const updateServiceFields = () => {
      const requestType = requestTypeField.value;
      const isShopRequest = requestType === 'Shop For Me';
      const isFindRequest = requestType === 'Find It For Me';

      setVisible(productLinks, isShopRequest, isShopRequest);
      setVisible(itemDescription, isFindRequest, isFindRequest);
      setVisible(budget, isFindRequest, isFindRequest);

      if (productLinks) {
        if (isShopRequest) productLinks.dataset.urlList = '';
        else delete productLinks.dataset.urlList;
        productLinks.minLength = isShopRequest ? 8 : 0;
      }

      [productLinks, itemDescription, budget].forEach(setValidationState);
    };

    const queryService = new URLSearchParams(window.location.search).get('service');
    if (!requestTypeField.value && queryService === 'shop-for-me') requestTypeField.value = 'Shop For Me';
    if (!requestTypeField.value && queryService === 'find-it-for-me') requestTypeField.value = 'Find It For Me';

    form.querySelector('textarea[name="contact[Order details]"]')?.setAttribute('minlength', '3');
    itemDescription?.setAttribute('minlength', '10');
    budget?.setAttribute('minlength', '2');

    addFieldExample(form, 'contact[WhatsApp]', 'Example: +233 20 148 4532');
    addFieldExample(form, 'contact[GPS Address]', 'Example: GA-123-4567 or a Google Maps pin');
    addFieldExample(form, 'contact[Product links]', 'Example: https://www.zara.com/… — add one product link per line.');
    addFieldExample(form, 'contact[Item description]', 'Example: “Nike trainers, women’s size 6, white, under £150.”');
    addFieldExample(form, 'contact[Budget]', 'Example: £150–£250 (optional store prices can be in GBP).');

    setRegions(countrySelect, regionSelect);
    countrySelect.addEventListener('change', () => setRegions(countrySelect, regionSelect));
    updateServiceFields();
    requestTypeField.addEventListener('change', updateServiceFields);

    form.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach((field) => {
      field.addEventListener('input', () => setValidationState(field));
      field.addEventListener('change', () => setValidationState(field));
      field.addEventListener('invalid', () => field.classList.add('is-invalid'));
    });
  };

  requestForms.forEach(prepareRequestForm);

  const submissionFrame = document.createElement('iframe');
  submissionFrame.name = 'swt-request-submission';
  submissionFrame.hidden = true;
  submissionFrame.setAttribute('aria-hidden', 'true');
  document.body.appendChild(submissionFrame);

  let requestIsSubmitting = false;

  submissionFrame.addEventListener('load', () => {
    if (!requestIsSubmitting) return;
    window.location.assign('/?view=request-received');
  });

  requestForms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      form.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach(setValidationState);
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }

      requestIsSubmitting = true;
      form.target = submissionFrame.name;

      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Sending your request…';
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (new URLSearchParams(window.location.search).get('view') !== 'request') return;

  const patchFormBuilderRequest = () => {
    const form = document.querySelector('.globo-formbuilder form[data-id="155620"]');
    if (!form || form.dataset.swtRequestBridge === 'ready') return;

    const productField = form.querySelector('textarea[name="textarea"]');
    const productControl = productField?.closest('.globo-form-control');
    if (!productControl) return;

    form.dataset.swtRequestBridge = 'ready';

    const serviceInput = form.querySelector('input[name="text"]');
    if (serviceInput) {
      const serviceSelect = document.createElement('select');
      serviceSelect.name = serviceInput.name;
      serviceSelect.id = serviceInput.id;
      serviceSelect.className = serviceInput.className;
      serviceSelect.required = true;
      serviceSelect.setAttribute('aria-required', 'true');

      [
        ['', 'Choose a service'],
        ['Shop For Me', 'Shop For Me — I have the product links'],
        ['Find It For Me', 'Find It For Me — please find the item'],
      ].forEach(([value, label], index) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        option.disabled = index === 0;
        option.selected = index === 0;
        serviceSelect.appendChild(option);
      });

      serviceInput.replaceWith(serviceSelect);

      const serviceHelp = [...form.querySelectorAll('p, span, small, div')].find(
        (element) => element.childElementCount === 0 && element.textContent.includes('Type exactly: Shop For Me or Find It For Me.'),
      );
      if (serviceHelp) serviceHelp.textContent = 'Choose either Shop For Me or Find It For Me.';
    }

    let descriptionField = form.querySelector('[name="textarea-1"]');
    if (!descriptionField) {
      const descriptionControl = productControl.cloneNode(true);
      descriptionField = descriptionControl.querySelector('textarea');
      const descriptionLabel = descriptionControl.querySelector('label');

      if (descriptionField && descriptionLabel) {
        descriptionField.name = 'textarea-1';
        descriptionField.id = 'swt-find-description';
        descriptionField.required = true;
        descriptionField.setAttribute('aria-required', 'true');
        descriptionField.value = '';
        descriptionField.placeholder = 'Describe the item you want us to find';
        descriptionLabel.setAttribute('for', 'swt-find-description');
        descriptionLabel.textContent = 'Describe what you want *';

        const descriptionHelp = [...descriptionControl.querySelectorAll('p, span, small, div')].find(
          (element) => element.childElementCount === 0 && element.textContent.includes('For Shop For Me:'),
        );
        if (descriptionHelp) {
          descriptionHelp.textContent = 'For Find It For Me: describe the item you want, including preferred brand, size, colour, quantity and any important details. If you are using Shop For Me, enter N/A here.';
        }

        productControl.insertAdjacentElement('afterend', descriptionControl);

        form.addEventListener('submit', () => {
          const details = descriptionField.value.trim();
          if (!details) return;

          const note = `Find It For Me details: ${details}`;
          const currentValue = productField.value.trim();
          if (!currentValue || currentValue.toLowerCase() === 'n/a') {
            productField.value = note;
          } else if (!productField.value.includes(note)) {
            productField.value += `\n\n${note}`;
          }
        }, true);
      }
    }

    const budgetHelp = [...form.querySelectorAll('p, span, small, div')].find(
      (element) => element.childElementCount === 0 && element.textContent.includes('Enter your maximum item budget in GBP.'),
    );
    if (budgetHelp) {
      budgetHelp.textContent = 'For Find It For Me: enter your maximum budget in GBP. If you are using Shop For Me, enter 0 here.';
    }
  };

  const addConfirmationRecommendations = () => {
    document.querySelectorAll('.globo-form-app[data-id="155620"] .message.success').forEach((message) => {
      if (message.dataset.swtRecommendations === 'ready') return;
      if (!message.getClientRects().length) return;

      const content = message.querySelector('.content');
      if (!content) return;

      const recommendations = document.createElement('section');
      recommendations.className = 'swt-request-recommendations';
      recommendations.setAttribute('aria-label', 'More from Theresa');
      recommendations.innerHTML = `
        <p class="swt-request-recommendations__eyebrow">More from Theresa</p>
        <p class="swt-request-recommendations__title">Take a look — these might interest you.</p>
        <p class="swt-request-recommendations__description">Explore, learn and stay updated.</p>
        <div class="swt-request-recommendations__links">
          <a href="https://www.instagram.com/heels_cottage/" target="_blank" rel="noopener noreferrer"><span class="swt-request-recommendations__platform">Instagram</span><span class="swt-request-recommendations__label">Heels Cottage</span><span class="swt-request-recommendations__cta">Explore the page <b aria-hidden="true">→</b></span></a>
          <a href="https://gyamfina.gumroad.com/" target="_blank" rel="noopener noreferrer"><span class="swt-request-recommendations__platform">Gumroad</span><span class="swt-request-recommendations__label">Cybersecurity<br>Resources</span><span class="swt-request-recommendations__cta">Visit Gumroad <b aria-hidden="true">→</b></span></a>
          <a href="https://www.youtube.com/@SheLearnsCyber" target="_blank" rel="noopener noreferrer"><span class="swt-request-recommendations__platform">YouTube</span><span class="swt-request-recommendations__label">She Learns<br>Cyber</span><span class="swt-request-recommendations__cta">Watch updates <b aria-hidden="true">→</b></span></a>
        </div>
      `;
      message.insertAdjacentElement('afterend', recommendations);
      message.dataset.swtRecommendations = 'ready';
    });
  };

  const updateConfirmationCopy = () => {
    const visibleMessages = Array.from(document.querySelectorAll('.globo-form-app[data-id="155620"] .message.success'))
      .filter((message) => message.getClientRects().length > 0);

    if (!visibleMessages.length) return;

    const setText = (element, text) => {
      if (element && element.textContent.trim() !== text) element.textContent = text;
    };

    visibleMessages.forEach((message) => {
      const title = message.querySelector('.gfb__content-title');
      setText(title, 'Thank you for your request');
      if (message.dataset.swtConfirmationCopy !== 'ready') message.dataset.swtConfirmationCopy = 'ready';
    });

    const heroCopy = document.querySelector('#MainContent .page-hero > div:not(.page-hero-aside)');
    const formHeading = document.querySelector('#MainContent .request-section .form-heading');
    const heroAside = document.querySelector('#MainContent .page-hero-aside p');

    if (heroCopy) {
      const eyebrow = heroCopy.querySelector('.eyebrow');
      const heading = heroCopy.querySelector('h1');
      const intro = heroCopy.querySelector('p');
      setText(eyebrow, 'Request received');
      setText(heading, 'Thank you for your request.');
      setText(intro, 'I’ll review your details and send your shopping invoice within the next 24 hours.');
    }

    if (formHeading) {
      const eyebrow = formHeading.querySelector('.eyebrow');
      const heading = formHeading.querySelector('h2');
      setText(eyebrow, 'Request received');
      setText(heading, 'Thank you for your request.');
    }

    setText(heroAside, '“Your international shopping journey starts here.”');
  };

  const observer = new MutationObserver(() => {
    patchFormBuilderRequest();
    addConfirmationRecommendations();
    updateConfirmationCopy();
  });
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'], childList: true, subtree: true });
  patchFormBuilderRequest();
  addConfirmationRecommendations();
  updateConfirmationCopy();
  window.setTimeout(patchFormBuilderRequest, 500);
  window.setTimeout(patchFormBuilderRequest, 1500);
  window.setTimeout(addConfirmationRecommendations, 500);
  window.setTimeout(addConfirmationRecommendations, 1500);
  window.setTimeout(updateConfirmationCopy, 500);
  window.setTimeout(updateConfirmationCopy, 1500);
});
